/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import { StoryCard } from "../basic/story-card.js";
import { CollectionName } from "../atoms/collection-name/index.js";
import PropTypes from "prop-types";

function CardGroup(props) {
  const majorStoryCardConfig = {
    subheadline: false,
    image: true,
    transparent: true
  };
  const card = get(props, ["stories", "0"], "");
  return (
    <div className=" component-wrapper card-group">
      <CollectionName
        name={props.config["collection-name"]}
        config={props.config}
        section={props.config["collection-section"]}
      />
      <div className="card-container">
        <div className="hero-card">
          <StoryCard hideSectionName={true} story={card} config={majorStoryCardConfig} />
        </div>
        <div className="other-cards">
          <StoryCard hideSectionName={true} story={props.stories[1]} />
          <StoryCard hideSectionName={true} story={props.stories[2]} />
          <StoryCard hideSectionName={true} story={props.stories[3]} />
        </div>
      </div>
    </div>
  );
}
CardGroup.propTypes = {
  config: PropTypes.object,
  stories: PropTypes.object,
  collection: PropTypes.object
};

export { CardGroup };
